import Feature from "src/js/stores/user/Feature";
import hasBetaFeature from "src/js/stores/user/actions/hasBetaFeature";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import { ComparablesFilterFields } from "../components/Filters/FiltersWithClear";

export const hiddenFieldsByFeature: Array<[() => boolean, Set<ComparablesFilterFields>]> = [
  [() => hasFeature(Feature.usAccess), new Set(["newBuildsOnly", "tenure"])],
  // Year built is shown in sites card for US; for non-US without Zoopla full access, hide year built and bedrooms
  [
    () => !hasFeature(Feature.zooplaFullAccess) && !hasFeature(Feature.usAccess),
    new Set<ComparablesFilterFields>(["bedrooms", "yearBuiltFrom", "yearBuiltTo"]),
  ],
  // Year built only visible with regrid migration beta
  [
    () => hasFeature(Feature.usAccess) && !hasBetaFeature(Feature.usReGridMigrationBeta),
    new Set<ComparablesFilterFields>(["yearBuiltFrom", "yearBuiltTo"]),
  ],
];
